import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from "react-accessible-accordion";
import { getBackgroundClass } from "../../utils/sectionHelpers";
import { HighlightText } from "./HighlightText";

const Faq = ({ data }) => {
  const settings = data?.Settings || {};

  const backgroundClass = getBackgroundClass(settings.background);
  return (
    <section className={`faq-section ptb-70  ${backgroundClass}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title">
              <h2><HighlightText content={data?.title} /></h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="faq-accordion">
              <Accordion allowZeroExpanded preExpanded={["0"]}>
                {data.faqs?.map((faq, index) => (
                  <AccordionItem key={faq.id} uuid={index.toString()}>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        {index + 1}. {faq.question}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div style={{ whiteSpace: "pre-line" }}>
                        {faq.answer && <p>{faq.answer}</p>}
                        {faq?.answers?.map((block, index) => {
                          switch (block.type) {
                            case "paragraph":
                              return (
                                <p key={index} className="mb-0">
                                  {block.children.map((child, i) => {
                                    let textElement = child.text;

                                    if (child.bold) {
                                      textElement = (
                                        <strong>{textElement}</strong>
                                      );
                                    }

                                    if (child.italic) {
                                      textElement = <em>{textElement}</em>;
                                    }

                                    if (child.underline) {
                                      textElement = <u>{textElement}</u>;
                                    }

                                    if (child.strikethrough) {
                                      textElement = <s>{textElement}</s>;
                                    }

                                    return (
                                      <React.Fragment key={i}>
                                        {textElement}
                                      </React.Fragment>
                                    );
                                  })}
                                </p>
                              );

                            case "heading":
                              const Tag = `h${block.level}`;
                              return (
                                <Tag key={index} className="mt-4 mb-3">
                                  {block.children.map((c) => c.text).join("")}
                                </Tag>
                              );

                            case "list":
                              return (
                                <ul key={index}>
                                  {block.children.map((item, i) => (
                                    <li key={i}>
                                      {item.children
                                        .map((c) => c.text)
                                        .join("")}
                                    </li>
                                  ))}
                                </ul>
                              );

                            default:
                              return null;
                          }
                        })}
                      </div>
                    </AccordionItemPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
